import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';

import * as fromUser from '../store/user.reducers';
import * as UserActions from '../store/user.actions';
import * as fromApp from '../../store/app.reducers';

import {matchFieldsValidator} from '../../helper/validators/match.validator';
import {Cookie} from '../../helper/cookie';
import * as fromTrial from '../../profile/trial/store/trial.reducers';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.scss'],
    standalone: false
})
export class UserEditComponent implements OnInit, OnDestroy {

  userState: Observable<fromUser.State>;
  userSubscription: Subscription;
  userForm: UntypedFormGroup;
  userEditPasswordForm: UntypedFormGroup;
  userId: number;
  cookies: Cookie;
  trialSubscription: Subscription;
  steps: any;

  constructor(
    public store: Store<fromApp.AppState>,
    public notifierService: ToastrService
  ) {
    this.initForm();
    this.cookies = new Cookie();
  }

  ngOnInit() {
    this.userState = this.store.select('user');
    if (this.cookies.getCookie('auditor-user-id')) {
      this.userId = +this.cookies.getCookie('auditor-user-id');
    }

    this.trialSubscription = this.store.select('trial').subscribe(
      (state: fromTrial.State) => {
        this.steps = state.steps;
      }
    );

    this.userSubscription = this.store.select('user').subscribe(
      (userState: fromUser.State) => {
        if (userState.user !== null) {
          console.log('user data loaded');
        }
      }
    );
  }

  initForm() {
    this.userForm = new UntypedFormGroup({
      'email': new FormControl(null, [Validators.required, Validators.email]),
      'password': new FormControl(null, [Validators.required]),
      'retyped_password': new FormControl(null, [Validators.required])
    }, [
      matchFieldsValidator('password', 'retyped_password')
    ]);
  }

  initEditPasswordForm() {
    this.userEditPasswordForm = new UntypedFormGroup({
      'password': new FormControl(null, [Validators.required, Validators.pattern(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{7,}/)]),
      'retyped_password': new FormControl(null, [Validators.required])
    }, [
      matchFieldsValidator('password', 'retyped_password')
    ]);
  }

  onSubmit() {
    const version = +this.cookies.getCookie('auditor-version');
    let url = ['/user/register/type'];
    if (version === 4) {
      url = ['/audits'];
    }
    if (version === 3) {
      url = this.steps.payment.url;
    }
    if (version === 5) {
      url = this.steps.payment.url;
    }

    if (!this.userForm.valid) {
      this.notifierService.warning('Fill in the form correctly');
      return;
    }
    this.store.dispatch(
      new UserActions.RegisterTrialUser({
        id: this.userId,
        email: this.userForm.value.email,
        password: this.userForm.value.password,
        retypedPassword: this.userForm.value.retyped_password,
        params: {
          redirectAfterSave: true,
          redirectUrl: url
        }
      })
    );
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.trialSubscription.unsubscribe();
  }

}
